import $ from 'jquery';
import Prefixed from 'modules/prefixed/prefixed';

export default class {
	constructor(options) {
		const defaults = {
			el: '.js-slider',
			dom: {
				slide: '.js-slider-slide',
				control: '.js-slider-control',
				page: '.js-slider-page',
				select: '.js-select'
			},
			classes: {
				theme: {
					white: 'b-slider_theme_white'
				},
				state: {
					animated: 'b-slider_state_animated'
				},
				pages: {
					hidden: 'b-slider_pages_hidden'
				},
				slide: {
					state: {
						active: 'b-slider__slide_state_active'
					},
					from: {
						prev: 'b-slider__slide_from_prev',
						next: 'b-slider__slide_from_next'
					},
					to: {
						prev: 'b-slider__slide_to_prev',
						next: 'b-slider__slide_to_next'
					}
				},
				page: {
					state: {
						active: 'b-slider__page_state_active'
					}
				}
			},
			callback: {
				start: false,
				end: false
			},
			time: false
		};


		this.options = $.extend(true, {}, defaults, options);
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		this.prefixed = new Prefixed();
		this.interval = false;
		this.pause = false;
		return this;
	}

	getDom() {
		const self = this;
		self.$slide = self.$el.find(self.options.dom.slide);
		self.$control = self.$el.find(self.options.dom.control);
		self.$page = self.$el.find(self.options.dom.page);
		self.$select = self.$el.find(self.options.dom.select);
		return self;
	}

	onComplete($active, $set, direction) {
		const self = this;
		$set.removeClass(self.options.classes.slide.from[direction]);
		$active.removeClass(self.options.classes.slide.to[direction]);
		self.$el.removeClass(self.options.classes.state.animated);
		if (typeof self.options.callback.end == 'function') {
			self.options.callback.end();
		}
		if (this.interval != false) {
			self.startTimer();
		}
		return self;
	}

	setSlide(eq, dir = false, force = false) {
		const self = this;
		const $active = self.$slide.filter('.' + self.options.classes.slide.state.active);
		const $set = self.$slide.eq(eq);
		if (!$active.is($set) && (!self.$el.hasClass(self.options.classes.state.animated) || force)) {
			if (force) {
				self.startTimer();
				self.$slide
					.removeClass(self.options.classes.slide.from.prev)
					.removeClass(self.options.classes.slide.from.next)
					.removeClass(self.options.classes.slide.to.prev)
					.removeClass(self.options.classes.slide.to.next)
					.removeClass(self.options.classes.slide.state.active)
					.off(self.prefixed.events.transitionEnd);
				$set.addClass(self.options.classes.slide.state.active);
			} else {
				self.pauseTimer(false);
				if (typeof self.options.callback.start == 'function') {
					self.options.callback.start(eq);
				}
				/* eslint no-nested-ternary: 0 */
				const direction = ((dir !== false) ? dir : ($active.index() < $set.index() ? 'next' : 'prev'));
				self.$el.addClass(self.options.classes.state.animated);
				$set.addClass(self.options.classes.slide.from[direction]);
				$set.one(self.prefixed.events.transitionEnd, self.onComplete.bind(self, $active, $set, direction));
				setTimeout(function () {
					$active
						.addClass(self.options.classes.slide.to[direction])
						.removeClass(self.options.classes.slide.state.active);
					$set.addClass(self.options.classes.slide.state.active);
				}, 50);
			}

			self.$page.not(':eq(' + eq + ')').removeClass(self.options.classes.page.state.active);
			self.$page.eq(eq).addClass(self.options.classes.page.state.active);

			const theme = $set.data('theme') || false;
			$.each(self.options.classes.theme, function (key, item) {
				self.$el.toggleClass(item, theme == key);
			});

		}
		return self;
	}

	nextSlide() {
		const self = this;
		const $active = self.$slide.filter('.' + self.options.classes.slide.state.active);
		let $set = $active.next();
		if (!$set.is(self.$slide)) {
			$set = self.$slide.eq(0);
		}
		self.setSlide($set.index(), 'next');
		return self;
	}

	prevSlide() {
		const self = this;
		const $active = self.$slide.filter('.' + self.options.classes.slide.state.active);
		let $set = $active.prev();
		if (!$set.is(self.$slide)) {
			$set = self.$slide.eq(-1);
		}
		self.setSlide($set.index(), 'prev');
		return self;
	}

	onControl(event) {
		const self = this;
		self[$(event.currentTarget).data('js')]();
		return self;
	}

	onPage(event) {
		const self = this;
		self.setSlide($(event.currentTarget).index());
		return self;
	}

	togglePage(show) {
		const self = this;
		if (typeof show !== 'undefined') {
			self.$el.toggleClass(self.options.classes.pages.hidden, !show);
		} else {
			self.$el.toggleClass(self.options.classes.pages.hidden);
		}
		return self;
	}

	startTimer() {
		const self = this;
		if (self.options.time != false) {
			clearInterval(self.interval);

			self.interval = setInterval(function () {
				self.nextSlide();
			}, self.options.time);
		}
	}

	pauseTimer(force) {
		clearInterval(this.interval);
		if (force !== false) {
			this.interval = false;
		}
	}

	render() {
		const self = this;
		if (self.$el.length) {
			self.getDom();

			self.$control.on('click', self.onControl.bind(self));
			self.$page.on('click', self.onPage.bind(self));

			self.$select
				.on('yota.select.open', self.togglePage.bind(self, false))
				.on('yota.select.close', self.togglePage.bind(self, true));

			self.$el
				.on('mouseenter', self.pauseTimer.bind(self))
				.on('mouseleave', self.startTimer.bind(self));


			self.startTimer();
		}
		return self;
	}
}



// WEBPACK FOOTER //
// ./app/blocks/slider/slider.js